import {
    CHANGE_STYES,
  } from "../actions/styleNameAction";
  
  const initialState = {
    CC_DI_CSS: "SYSCO_CSS",
    CC_DI_JS: "SYSCO_JS",
    RONE_CSS: "default.css",
  };
  
  const styleNameReducer = (state = initialState, action) => {
    switch (action.type) {
      case CHANGE_STYES:
        return {
          ...state,
          CC_DI_CSS: action.payload.CC_DI_CSS,
          CC_DI_JS: action.payload.CC_DI_JS,
          RONE_CSS: action.payload.RONE_CSS,
        };
  
      default:
        return state;
    }
  };
  
  export default styleNameReducer;
  